import { Dialog, DialogProps } from "@mui/material";
import { ValidateOn } from "@ngt/forms-core";
import { CrfFormByCodesProvider, InstitutionByCodeProvider } from "@ngt/opms";
import { FC, useCallback } from "react";
import { RegistrationFormContent } from "../RegistrationForm";
import { CrfDialogForm } from "./CrfDialogForm";

interface IRegistrationDialogFormProps extends DialogProps {
    institutionCode?: string,
    onAfterSubmit?: () => Promise<any>,
    closeOnSubmit?: boolean,
    closeForm?: () => any
}

const RegistrationDialogForm: FC<IRegistrationDialogFormProps> = ({
    institutionCode,
    onAfterSubmit,
    closeForm,
    closeOnSubmit,
    open,
    ...rest
}) => {

    const handleSubmit = useCallback(async () => {
        if (onAfterSubmit) {
            await onAfterSubmit();
        }
        if (closeForm && closeOnSubmit) {
            closeForm();
        }
    }, [onAfterSubmit, closeForm, closeOnSubmit]);

    return (
        <InstitutionByCodeProvider institutionCode={institutionCode}>
            <CrfFormByCodesProvider
                eventDefinitionIdentifier={'baseline'}
                eventRepeat={1}
                formDefinitionIdentifier={'registration'}
                formRepeat={1}
                loadBeforeMount
                institutionCode={institutionCode}
                createPatient
                createEvent
                createForm
            >
                <Dialog
                    open={open}
                    {...rest}
                >
                    {
                        open &&
                        <CrfDialogForm
                            hideSubmitAndReturn
                            dialogTitle="Registration"
                            validateOn={ValidateOn.onChange}
                            onAfterSubmit={handleSubmit}
                            onCancel={closeForm}
                        >
                            <RegistrationFormContent />
                        </CrfDialogForm>
                    }
                </Dialog>
            </CrfFormByCodesProvider>
        </InstitutionByCodeProvider>
    )
}

export default RegistrationDialogForm;